import axios from "axios";

var Terms = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function () {
        return axios.get(Apollo.resolveApiUrl("~/terms"),{});
    },
    accept: function () {
        return axios.post(Apollo.resolveApiUrl("~/terms"), { "Accepted": true});
    }
};

export default Terms;



// WEBPACK FOOTER //
// ./src/models/Terms.js